import { Breadcrumb, BreadcrumbItem } from 'flowbite-react';
import { Link } from 'react-router-dom';
import { HiHome } from 'react-icons/hi';

interface BreadcrumbLink {
  label: string;
  href?: string;
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbLink[];
  actions?: React.ReactNode;
  /** Shown before the title, e.g. an organization's logo */
  leading?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  breadcrumbs,
  actions,
  leading,
  className = ''
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumb className="mb-4" aria-label="Breadcrumb navigation">
          <BreadcrumbItem icon={HiHome}>
            <Link to="/" className="inline-flex items-center text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 underline hover:no-underline">
              Home
            </Link>
          </BreadcrumbItem>
          {breadcrumbs.map((crumb, index) => (
            <BreadcrumbItem key={index}>
              {crumb.href ? (
                <Link to={crumb.href} className="inline-flex items-center text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 underline hover:no-underline">
                  {crumb.label}
                </Link>
              ) : (
                <span className="inline-flex items-center text-gray-500 dark:text-gray-400">{crumb.label}</span>
              )}
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
      )}

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-4 min-w-0">
          {leading}
          <div className="min-w-0">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{title}</h1>
            {subtitle && (
              <p className="mt-1 text-gray-600 dark:text-gray-400">{subtitle}</p>
            )}
          </div>
        </div>

        {actions && (
          <div className="flex gap-2">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};
